/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-09-05 14:18:54
 * @Description: 大华摄像接口列表
 * @LastEditors: Please set LastEditors
 */
import To from 'await-to-js'
import qs from 'qs'
// eslint-disable-next-line import/no-cycle
import CallbackDH from '@/services/CallbackDH'
import { wizStandardInstance } from './instance'

export default class dhServer {
  static async getPublicKey() {
    const [err, res] = await To(
      wizStandardInstance.get('/evo-apigw/evo-oauth/1.0.0/oauth/public-key')
    )
    return CallbackDH(err, res)
  }

  // 登录，获取token
  static async oauthSystem(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/evo-oauth/1.0.0/oauth/extend/token', payload)
    )
    return CallbackDH(err, res)
  }
  // 用户保活

  static async userKeepAlive(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/evo-brm/1.2.0/user/keepalive', payload)
    )
    return CallbackDH(err, res)
  }
  // 刷新token
  static async refreshToken(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/evo-oauth/1.0.0/oauth/extend/refresh/token', payload)
    )
    return CallbackDH(err, res)
  }
  // 开启实时监控预览
  static async livePreview(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/admin/API/MTS/Video/StartVideo', payload)
    )
    return CallbackDH(err, res)
  }
  // 开启云台操作
  static async controlCameraMove(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/admin/API/DMS/Ptz/OperateDirect', payload)
    )
    return CallbackDH(err, res)
  }
  // 开启回放
  static async startPlayback(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/admin/API/SS/Playback/StartPlaybackByTime', payload)
    )
    return CallbackDH(err, res)
  }
  // 控制云台镜头的变焦、变倍及光圈大小
  static async operateCamera(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/admin/API/DMS/Ptz/OperateCamera', payload)
    )
    return CallbackDH(err, res)
  }
  // 获取人员信息
  static async getPersonPageInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/evo-brm/1.0.0/person/subsystem/page', payload)
    )
    return CallbackDH(err, res)
  }
  // 获取部门树
  static async getDepartmentTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/evo-apigw/evo-brm/1.0.0/department/tree', payload)
    )
    return CallbackDH(err, res)
  }
  // 获取门禁信息
  static async getEntranceGuard(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/evo-apigw/evo-accesscontrol/1.0.0/card/accessControl/swingCardRecord/bycondition/combined?${qs.stringify(
          payload.params
        )}`,
        payload.bodyForm
      )
    )
    return CallbackDH(err, res)
  }
}
